var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperstructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9873 40.9509V4.96191H5.99829V40.9509H1.99951V46.9491H45.9861V40.9509H41.9873ZM37.9885 8.96069V22.9564H33.9897V8.96069H37.9885ZM9.99707 8.96069H13.9958V22.9564H9.99707V8.96069ZM9.99707 40.9509V26.9552H13.9958V40.9509H9.99707ZM17.9946 40.9509V8.96069H29.991V40.9509H17.9946ZM33.9897 40.9509V26.9552H37.9885V40.9509H33.9897Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9945 13.9592H29.9908",
    stroke: "#A3AED0",
    strokeWidth: 2.99908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.96313L8 14.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 6.96313L14 16.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.963L8 22.963",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.96313L8 18.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 6.96313L20 14.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.9631L8 26.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.9631L8 32.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28.9631L8 36.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.9631L8 40.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36.9631L8 44.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 6.96313L24 14.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 6.96313L32 14.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10.9631L32 18.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 14.963L32 22.963",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 18.9631L32 26.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 24.9631L32 32.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 28.9631L32 36.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32.9631L32 40.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 36.9631L32 44.9631",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.963257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperstructure);
export default __webpack_public_path__ + "static/media/Superstructure.fad6c21f2e6127d38731781f4fea5078.svg";
export { ForwardRef as ReactComponent };